export default __webpack_public_path__ + "static/media/HR.cd378677.png";